(function() {
  let tooltipCounter = 0;

  document.addEventListener('DOMContentLoaded', (event) => {
    window.addEventListener("scroll", function() {
      removeTooltips();
    });

    document.body.addEventListener("click", function(e) {
      setTimeout(function() {
        removeTooltips();
      }, 300);
    });
  });

  function removeTooltips() {
    var tooltipSelector = '#TooltipLayer';
    var currentTooltip;
    var tooltipLength = [...document.querySelectorAll('div')].filter(e => e.id.includes('TooltipLayer')).length; 
    for (var i = tooltipCounter; i < tooltipCounter + tooltipLength; i++) {
      currentTooltip = document.querySelector(tooltipSelector + i);
      if (currentTooltip) {
        document.querySelector(tooltipSelector + i).remove();
        tooltipCounter = i;
      }
    }
  }
})();

/**************** COOKIE PIE APP STUFF ***************/

document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', function(event) {
  document.getElementById("toggle--template--16757651964159__3b5ee500-2ddc-4698-ae7f-8c32fae26836-text-1").innerHTML = "<p>Cookie Pie Nutritional Information:<span id=\"values\"></span><br/>Number of servings: 8</p><table class=\"nutrition\"><tr><th class=\"nutrition-heading\">Item</th><th class=\"nutrition-heading\">Per Serve: <span id=\"serving-size-base\">0</span>g</th><th class=\"nutrition-heading\">Per 100g</th></tr><tr><td class=\"data\">Energy (kj)</td><td class=\"data\" id=\"energy-per-serve-base\">0</td><td class=\"data\" id=\"energy-per-100g-base\">0</td></tr><tr><td class=\"data\">Calories (Cal)</td><td class=\"data\" id=\"calories-per-serve-base\">0</td><td class=\"data\" id=\"calories-per-100g-base\">0</td></tr><tr><td class=\"data\">Protein (g)</td><td class=\"data\" id=\"protein-per-serve-base\">0</td><td class=\"data\" id=\"protein-per-100g-base\">0</td></tr><tr><td class=\"data\">Fat (g)</td><td class=\"data\" id=\"fat-per-serve-base\">0</td><td class=\"data\" id=\"fat-per-100g-base\">0</td></tr><tr><td class=\"data\">Saturated Fat (g)</td><td class=\"data\" id=\"sat-fat-per-serve-base\">0</td><td class=\"data\" id=\"sat-fat-per-100g-base\">0</td></tr><tr><td class=\"data\">Carbohydrates (g)</td><td class=\"data\" id=\"carb-per-serve-base\">0</td><td class=\"data\" id=\"carb-per-100g-base\">0</td></tr><tr><td class=\"data\">Sugars (g)</td><td class=\"data\" id=\"sugar-per-serve-base\">0</td><td class=\"data\" id=\"sugar-per-100g-base\">0</td></tr><tr><td class=\"data\">Sodium (g)</td><td class=\"data\" id=\"sodium-per-serve-base\">0</td><td class=\"data\" id=\"sodium-per-100g-base\">0</td></tr></table>";
  var x = CPB.getStore().getState().Product;
  var a = [];
  var z = x.userChanges.CGY2EkVjRoONRdydfW7WxzFf;
  //console.log(z);
  var y = Object.keys(z);
  var c = [];
  var e;
  var g = [];
  var g1 = [];
  //console.log(y);
  y.forEach(function(item){
    var b = item; 
    console.log(z[b]);
    if (z[b].value != '') {
      c.push(x.userChanges.CGY2EkVjRoONRdydfW7WxzFf[b].option);
      value = ' ' + z[b].value;
      g1.push(value);
    }
  });
  console.log(g1);
  c.forEach(function(item) {
    var d = x.panels[0].categories;
    for (let i = 0; i < d.length; i++) {
       e = d[i].options;
       for (let j = 0; j < e.length; j++) {
          f = e[j].id;
          if (f == item) {
            //console.log(f);
            var h = e[j].metafields;
            g.push(h);
          }
       }
    }  
  });
  console.log(g);
  try {
    g[0].map(function(item) {
      if (item.key == 'ingredients' || item.key == 'allergens') {
        console.log(item);
        var key = item.key;
        var result = key.concat("-base");
        var value = item.value;
        value = String(value);
        console.log(value);
        document.getElementById(result).innerHTML = value;
      }
    });
  } catch (error) {
    //console.log(error);
  }
  try {
    g[1].map(function(item) {
      if (item.key == 'ingredients' || item.key == 'allergens') {
        var key = item.key;
        var result = key.concat("-fill");
        var value = item.value;
        try {
          document.getElementById(result).innerHTML = value;
        } catch (error) {
          console.error(error);
        }
      }
    });
  } catch (error) {
    console.log(error);
  }
  try {
  g[2].map(function(item) {
    if (item.key == 'ingredients' || item.key == 'allergens') {
      var key = item.key;
      var result = key.concat("-top");
      var value = item.value;
      try {
        document.getElementById(result).innerHTML = value;
      } catch (error) {
        console.error(error);
      }
    }
  });
  } catch (error) {
    console.log(error);
  }
  m = [];
  n = [];
  o = [];
  p = [];
  no = [];
  nop = [];
  //console.log(g);
  g[0].map(function(item) {
    m.push(item.key);
  }); 
  n = g[0];
  try {
    o = g[1];
  } catch (error) {
    //console.error(error);
    o = [];
  }
  try {
    p = g[2];
  } catch (error) {
    //console.error(error);
    p = [];
  }
  no = n.concat(o);
  nop = no.concat(p);
  //console.log(nop);
  m.forEach(function(item) {
    /*var total = nop.reduce((accumulator, object) => {
      try {
        if (object.key == item) {
          return accumulator + 5;
        } 
      } catch (error) {
        console.error(error);
      }
    }, 0);*/
    var sum = 0;
    nop.forEach(element => {
      try {
        if (element.key == item) {
            price = parseFloat(element.value);
            sum += price;
        } 
      } catch (error) {
        //console.error(error);
        
      }
    });
    if (item.includes("serv") == false) {
      sum = sum/g.length;     
    }
    var key = item;
    var result = key.concat("-base");
    try {
      document.getElementById(result).innerHTML = sum.toFixed(1);
      //console.log(result," : ",sum);
    } catch (error) {
      //console.error(error);
    }
    var values = g1.toString()
    try {
      document.getElementById("values").innerHTML = values;
      //console.log(result," : ",sum);
    } catch (error) {
      //console.error(error);
    }
  });
});

window.addEventListener("load", (event) => {
  document.getElementById("toggle--template--16757651964159__3b5ee500-2ddc-4698-ae7f-8c32fae26836-text-1").innerHTML = "<p>Cookie Pie Nutritional Information:<span id=\"values\"></span><br/>Number of servings: 8</p><table class=\"nutrition\"><tr><th class=\"nutrition-heading\">Item</th><th class=\"nutrition-heading\">Per Serve: <span id=\"serving-size-base\">0</span>g</th><th class=\"nutrition-heading\">Per 100g</th></tr><tr><td class=\"data\">Energy (kj)</td><td class=\"data\" id=\"energy-per-serve-base\">0</td><td class=\"data\" id=\"energy-per-100g-base\">0</td></tr><tr><td class=\"data\">Calories (Cal)</td><td class=\"data\" id=\"calories-per-serve-base\">0</td><td class=\"data\" id=\"calories-per-100g-base\">0</td></tr><tr><td class=\"data\">Protein (g)</td><td class=\"data\" id=\"protein-per-serve-base\">0</td><td class=\"data\" id=\"protein-per-100g-base\">0</td></tr><tr><td class=\"data\">Fat (g)</td><td class=\"data\" id=\"fat-per-serve-base\">0</td><td class=\"data\" id=\"fat-per-100g-base\">0</td></tr><tr><td class=\"data\">Saturated Fat (g)</td><td class=\"data\" id=\"sat-fat-per-serve-base\">0</td><td class=\"data\" id=\"sat-fat-per-100g-base\">0</td></tr><tr><td class=\"data\">Carbohydrates (g)</td><td class=\"data\" id=\"carb-per-serve-base\">0</td><td class=\"data\" id=\"carb-per-100g-base\">0</td></tr><tr><td class=\"data\">Sugars (g)</td><td class=\"data\" id=\"sugar-per-serve-base\">0</td><td class=\"data\" id=\"sugar-per-100g-base\">0</td></tr><tr><td class=\"data\">Sodium (g)</td><td class=\"data\" id=\"sodium-per-serve-base\">0</td><td class=\"data\" id=\"sodium-per-100g-base\">0</td></tr></table>";
});

// function getProductConfig() {
//   var result = [];
//   var product = CPB.getStore().getState().Product;
//   var changes = product.userChanges.CGY2EkVjRoONRdydfW7WxzFf;
//   var panels = Object.keys(changes);
//   panels.forEach(function(panelId) {
//     var title = '';
    
//   }
//   return result;
// }

// function getProductConfig() {
//   var result = [];
//   var product = CPB.getStore().getState().Product;
//   var changes = product.userChanges.CGY2EkVjRoONRdydfW7WxzFf;
//   var changes1 = product.userChanges;
//   var panels = Object.keys(changes);
//   panels.forEach(function(panelId) {
//     var title = '';
//     product.panels.forEach(function(panel) {
//         console.log("Title: ", panel);
//         if(panel.id === panelId) title = panel.title;
//     });
//     //console.log("Title: ", panel.title);
//     var panel = {
//       title: title,
//       categories: []
//     }
//     var categories = Object.keys(changes[panelId]);
//     categories.forEach(function(categoryId) {
//       var catLayer = changes[panelId][categoryId].layer;
//       var selectedOption = catLayer.option;
//       var catObj = catLayer.categoryObj;
//       var category = {
//         title: catObj.title,
//         options: []
//       }
//       catObj.options.forEach(function(option) {
//         if(option.id === selectedOption) {
//           var title = catObj.type === 'input' ? catLayer.value : option.option.data.label;
//           category.options.push({
//             title: title,
//             sku: option.sku
//           });
//         }
//       });
//       panel.categories.push(category);
//     });
//     result.push(panel);
//   });
//   return result;
// }

  /** 
   * Function wait CPB DOM elements to show up.
   * Work in modern browsers.
   * And execute callback.
   */
  var cpbLoaded = function() {
    if (jQuery('#react-tabs-2').length > 0) {
      
      console.log('CPB is loaded');
      
      //customJS();
    } else {
      window.requestAnimationFrame(cpbLoaded);
    }   
  };

  cpbLoaded();

  var changeAddToCartText = (function() {
      if( $('.cpb-add-to-cart-button span').length) {
        $('.cpb-add-to-cart-button span').text('Hello');
      } else {
        window.requestAnimationFrame(changeAddToCartText);
      }   
});